import { RxCollection, RxCollectionCreator, RxJsonSchema } from "rxdb"
import { WorkspaceDetail } from "src/util/types/dataModels/workspace"

//region Types

export type WorkspaceCollection = RxCollection<WorkspaceDetail>

//endregion

/**
 * Schema for Workspace collections
 */
export const WorkspaceSchema: RxJsonSchema<WorkspaceDetail> = {
  title: "Workspace schema",
  description: "Workspaces for a particular user",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    organisation: {
      type: "object",
      properties: {
        id: { type: "number", maxLength: 36, uniqueItems: true },
        name: { type: "string", minLength: 1, maxLength: 255 },
        address: { type: "string", minLength: 1, maxLength: 255 },
        logo: { type: "string" },
        vpc: { type: "string", maxLength: 36 },
        service_provider: { type: "string", maxLength: 36 },
        account_owners: {
          type: "array",
          items: {
            type: "string",
            maxLength: 36,
          },
        },
      },
      required: ["id", "name", "vpc", "service_provider", "account_owners"],
    },
    stats: {
      type: "object",
      properties: {
        num_items: { type: "number" },
        num_areas: { type: "number" },
        num_issues: { type: "number" },
        num_layouts: { type: "number" },
        num_locations: { type: "number" },
        num_models: { type: "number" },
        num_zones: { type: "number" },
        num_work_orders: { type: "number" },
        num_change_requests: { type: "object" },
        issue_highest_priority: { type: "string", minLength: 1 },
        work_order_highest_priority: { type: "number" },
        total_health_percent: { type: "number" },
        time_zone: { type: "string", minLength: 1 },
      },
    },
    admins: {
      type: "array",
      items: {
        type: "string",
        maxLength: 36,
      },
    },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    name: { type: "string", minLength: 1, maxLength: 255 },
    group: { type: "string", minLength: 1, maxLength: 255 },
    description: { type: "string" },
    image: { type: "string" },
    coordinates: { type: "string", maxLength: 64 },
    time_zone: { type: "string", maxLength: 64 },
  },
  required: ["id", "organisation", "name"],
  indexes: ["name"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const workspaceCollectionCreator: RxCollectionCreator = {
  schema: WorkspaceSchema,
}
